import { StyleContentWrapper } from './panelBooking.styled'
import { Button } from 'components/atoms'
import { TabButton } from 'components/templates'
import { IOptionItem } from 'interfaces'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleContainerCard } from 'styles/styledGlobal'

interface IProps {
  selectedCount?: number
  onChange?: (item: IOptionItem) => void
  totalRecord?: number
  tabsButton?: any
  tabDefault?: any
}

const PanelBooking = (props: IProps) => {
  const { t } = useTranslation()
  const { selectedCount, onChange, tabsButton, tabDefault } = props
  const [tab, setTab] = useState(tabDefault)

  const handleOnChange = (tab: IOptionItem) => {
    setTab(tab)
    if (onChange) onChange(tab)
  }

  tabsButton?.forEach((item: any) => {
    if (tab?.label === item?.label) {
      item.count = undefined
    } else {
      item.count = undefined
    }
  })

  useEffect(() => {
    setTab(tabDefault)
  }, [tabsButton])

  return (
    <StyleContainerCard>
      <StyleContentWrapper>
        <TabButton
          tabs={tabsButton}
          onChange={handleOnChange}
          tab={tab}
          showCount
        />
        {!!selectedCount && (
          <Button color="red">
            {t('delete')}({selectedCount})
          </Button>
        )}
      </StyleContentWrapper>
    </StyleContainerCard>
  )
}

export default PanelBooking
